import React, {Component} from 'react';
import {ColumnsSelect} from "./ColumnSelect";
import {MANDATORY_COLUMNS} from "./columns";
import {FaIcon} from "../../FaIcon";

export class ColumnMappingConfiguration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            column: this.props.column,
            header: this.props.header
        };

        this.handleColumnChange = this.handleColumnChange.bind(this);
        this.handleHeaderChange = this.handleHeaderChange.bind(this);
    }

    handleColumnChange(newColumn) {
        this.props.onValueChange(this.props.order, newColumn, this.state.header);

        this.setState({
            column: newColumn
        });
    }

    handleHeaderChange(event) {
        const newHeader = event.target.value !== "" ? event.target.value : null;

        this.props.onValueChange(this.props.order, this.state.column, newHeader);

        this.setState({
            header: newHeader
        });
    }

    renderLabelColumn() {
        if(this.renderLabels === true) {
            return <label>El valor de</label>;
        }
    }

    renderLabelHeader() {
        if(this.renderLabels === true) {
            return <label>está en la columna</label>;
        }
    }

    isReadOnly() {
        // Si se trata de una columna MANDATORY, es read only
        //return (MANDATORY_COLUMNS.includes(this.props.column));
        return true; // Hay un input por metrica. No hace falta que sea un select
    }

    getRequiredAttForHeaderSelect() {
        return MANDATORY_COLUMNS.includes(this.state.column);
    }

    renderHeaderSelect() {
        if(!this.props.headersOptions) {
            return <input type="text" className={"form-control"} readOnly={true} />;
        }

        const isRequired = this.getRequiredAttForHeaderSelect();

        const headerValue = (this.state.header === null && this.props.header !== null) ? this.props.header : this.state.header;

        return (<select className={"form-control"}
                        value={headerValue}
                        onChange={this.handleHeaderChange}
                        required={isRequired}
        >
            <option value="" key="no-mapped">------</option>
            {this.props.headersOptions.map((option) => (
                <option value={option}
                        key={option}
                >{option}</option>
            ))}
        </select>);
    }

    render() {
        return (
            <div className="form-row">
                <div className="col">
                    {this.renderLabelColumn()}
                    <ColumnsSelect onChange={this.handleColumnChange} readOnly={this.isReadOnly()} selected={this.state.column} />
                </div>
                <div className="col-auto pt-2">
                    <FaIcon iconName="arrow-right" style={{color:"#4A4A4A"}} />
                </div>
                <div className="col">
                    {this.renderLabelHeader()}
                    {this.renderHeaderSelect()}
                </div>
            </div>
        );
    }
}
